import { constants } from '../config';

export const showModalRedirectToRegister = (show) => ({
  type: constants.SHOW_MODAL,
  show,
});
